<template>
  <div>
    <div :id="id" class="tree">
      <div v-for="block in blocks" :key="block.id" class="section">
        <div class="block-container my-1" @dragover="(e) => dragOver(e, block.id)">
          <div class="block d-flex flex-column bg-white border w-100">
            <div class="d-flex align-items-center justify-content-between border-bottom p-3">
              <div class="d-flex">
                <!-- DRAG BUTTON -->
                <span
                  draggable
                  @dragstart="(e) => dragStart(e, block.id)"
                  @dragend="dragEnd"
                  style="color: #999; margin-right: 12px"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    style="width: 20px; height: 20px"
                  >
                    <path d="M0 2h20v2H0zM0 9h20v2H0zM0 16h20v2H0z" stroke-linecap="round" />
                  </svg>
                </span>
                <div class="font-weight-bold">
                  <span class="block-title" v-if="block.model_type_id === blockTypes.text">Текст</span>
                  <span class="block-title" v-else-if="block.model_type_id === blockTypes.video">Видео</span>
                  <span class="block-title" v-else-if="block.model_type_id === blockTypes.audio">Аудио</span>
                  <span class="block-title" v-else-if="block.model_type_id === blockTypes.file">Файл</span>
                  <span class="block-title" v-else-if="block.model_type_id === blockTypes.image">Фото</span>
                  <span class="block-title" v-else-if="block.model_type_id === blockTypes.test">Тест</span>
                  <span class="block-title" v-else-if="block.model_type_id === blockTypes.survey">Опрос</span>
                  <span class="block-title" v-else-if="block.model_type_id === blockTypes.homework"
                    >Домашнее задание</span
                  >
                </div>
              </div>
              <div class="d-flex align-items-center">
                <b-icon-chevron-down v-b-toggle="`lb${block.id}`" scale="1.25" class="block-collapse" />
                <button
                  v-if="
                    block.model_type_id === blockTypes.video &&
                    block.video.iframe_src &&
                    ~block.video.iframe_src.indexOf('vimeo.com')
                  "
                  title="Установить превью для видео"
                  @click="toggleSettingVimeoPreview(block.video)"
                  class="toggle-vimeo-preview"
                >
                  <i class="flaticon2-image-file" />
                </button>
                <b-form-checkbox
                  switch
                  size="sm"
                  style="margin-left: 1.5rem; margin-right: 0.75rem; min-height: 0; line-height: 1.15"
                  class="pb-0"
                  v-model="block.enabled"
                  @change="updateBlock(block)"
                />
                <b-icon-x class="block-remove" scale="1.5" @click="deleteBlock(block.id)" />
              </div>
            </div>
            <b-collapse :id="`lb${block.id}`" visible>
              <text-block
                v-if="block.model_type_id === blockTypes.text"
                v-model="block.content"
                @update="updateBlock(block)"
              />
              <video-block
                v-else-if="block.model_type_id === blockTypes.video"
                v-model="block.video"
                @update="updateBlock(block)"
                :isDragging="!!draggedId"
                :showSettingPreview="!!~showSettingVimeoPreviewIds.indexOf(block.video.id)"
              />
              <file-block
                v-else-if="block.model_type_id === blockTypes.file"
                v-model="block.files"
                @update="updateBlock(block)"
              />
              <file-block
                v-else-if="block.model_type_id === blockTypes.audio"
                v-model="block.audio"
                audio
                @update="updateBlock(block)"
              />
              <image-block
                v-else-if="block.model_type_id === blockTypes.image"
                v-model="block.image"
                @update="updateBlock(block)"
              />
              <test-block
                v-else-if="block.model_type_id === blockTypes.test"
                v-model="block.test"
                :isManage="isManage"
                @update="updateBlock(block)"
              />
              <survey-block
                v-else-if="block.model_type_id === blockTypes.survey"
                v-model="block.survey"
                :isManage="isManage"
                @update="updateBlock(block)"
              />
              <homework-block
                v-else-if="block.model_type_id === blockTypes.homework"
                v-model="block.homework"
                @update="updateBlock(block)"
              />
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/custom/colors.scss";
.block-collapse,
.block-remove {
  stroke: #999;
  cursor: pointer;
  &:hover {
    stroke: #666 !important;
  }
  &:active {
    stroke: #333 !important;
  }
}
.tree {
  display: flex;
  flex-direction: column;
  .section {
    display: flex;
    flex-direction: column;
    position: relative;
    .block-container {
      [draggable] {
        cursor: grab;
      }
    }
  }
}

#drag-placeholder {
  .line {
    margin-left: -1px;
    margin-right: -1px;
    height: 2px;
    background-color: #5867dd;
  }
  .arrow {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    &.left {
      border-right-color: #5867dd;
      border-left: none;
    }
    &.right {
      border-left-color: #5867dd;
      border-right: none;
    }
  }
}
.toggle-vimeo-preview {
  color: #999;
  margin-left: 1.5rem;
  &:hover {
    color: $primary;
  }
}
</style>

<script>
import {
  BIconX,
  BIconChevronLeft,
  BIconCardText,
  BIconFileEarmarkText,
  BIconPlayBtn,
  BIconImage,
  BIconChevronDown,
} from "bootstrap-vue";

import Api from "shared/service/api/api";
import TextBlock from "shared/widgets/lesson/blocks/TextBlock.vue";
import FileBlock from "shared/widgets/lesson/blocks/FileBlock.vue";
import VideoBlock from "shared/widgets/lesson/blocks/VideoBlock.vue";
import ImageBlock from "shared/widgets/lesson/blocks/ImageBlock.vue";
import TestBlock from "shared/widgets/lesson/blocks/TestBlock.vue";
import SurveyBlock from "shared/widgets/lesson/blocks/SurveyBlock.vue";
import HomeworkBlock from "shared/widgets/lesson/blocks/HomeworkBlock.vue";
import { mapMutations } from "vuex";

export default {
  name: "LessonBlockTree",
  props: {
    newBlock: {
      type: String,
      required: false,
    },
    isManage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BIconX,
    BIconChevronLeft,
    BIconCardText,
    BIconFileEarmarkText,
    BIconPlayBtn,
    BIconImage,
    BIconChevronDown,
    FileBlock,
    TextBlock,
    VideoBlock,
    ImageBlock,
    TestBlock,
    SurveyBlock,
    HomeworkBlock,
  },
  watch: {
    newBlock() {
      this.newBlock && this.addBlock(this.blockTypes[this.newBlock], this.newBlock);
    },
  },
  computed: {
    lessonId() {
      return Number(this.$route.params.lessonId);
    },
    placement: () => ({
      beforeLessonBlock: -1,
      afterLessonBlock: 1,
    }),
    blockTypes() {
      return {
        text: 15,
        video: 16,
        file: 17,
        image: 18,
        test: 21,
        survey: 23,
        homework: 25,
        audio: 28,
      };
    },
    apiNamespace() {
      return this.isManage ? Api.admin.course.lesson.block : Api.course.lesson.block;
    },
  },
  data() {
    return {
      id: null,
      draggedId: null,
      draggedOver: {
        blockId: null,
        placement: null,
      },
      blocks: null,
      showSettingVimeoPreviewIds: [],
    };
  },
  created() {
    this.id = "LessonBlockTree_" + Date.now();
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapMutations("autocomplete/video", ["reset"]),
    load() {
      this.apiNamespace
        .all(this.lessonId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.blocks = response.data;
        })
        .catch((e) => {
          this.$alert.error("Ошибка загрузки данных урока курса<br>" + e.message);
        });
    },
    /* DRAG */
    dragStart(e, blockId) {
      e.target.style.opacity = 0.5;
      this.draggedId = blockId;
      this.draggedOver = {
        blockId: blockId,
        placement: this.placement.beforeLessonBlock,
      };
    },
    dragEnd({ target }) {
      target.style.opacity = 1;
      this.removeDragPlaceholder();

      if (this.draggedId === this.draggedOver.blockId) {
        this.resetDragData();
        return;
      }

      let draggedBlock = this.blocks.find((b) => b.id === this.draggedId);
      const draggedOverBlock = this.blocks.find((b) => b.id === this.draggedOver.blockId);

      try {
        const weightDiff = 5;
        const newWeight = draggedOverBlock.weight + this.draggedOver.placement * weightDiff;

        // prevent putting an element right before itself
        if (Math.abs(draggedBlock.weight - newWeight) === weightDiff) {
          throw new Error();
        }

        draggedBlock.weight = newWeight;
        // show user that the block has been moved
        // since array.find() returns a reference, we don't need to make any changes in the array, only sort it
        this.blocks.sort((left, right) => left.weight - right.weight);
        this.saveBlock(draggedBlock);
      } catch {}

      this.resetDragData();
    },
    resetDragData() {
      this.draggedId = null;
      this.draggedOver = {
        blockId: null,
        placement: null,
      };
    },
    dragOver(e, blockId) {
      if (!this.draggedId) {
        return;
      }

      // calculate where mouse is relative to the dragged over element
      const blockContainer = e.target.closest(".block-container");
      const clientRect = blockContainer.getBoundingClientRect();
      const percentage = (e.clientY - clientRect.top) / clientRect.height;
      const placement = Math.sign(percentage - 0.5);
      this.draggedOver = {
        blockId: blockId,
        placement: placement,
      };

      this.removeDragPlaceholder();
      const dragPlaceholder = this.createDragPlaceholder();
      dragPlaceholder.setAttribute("style", `${placement === 1 ? "bottom" : "top"}: -5px`);
      blockContainer.insertAdjacentElement(placement === 1 ? "afterend" : "beforebegin", dragPlaceholder);
    },
    createDragPlaceholder() {
      const newPlaceholder = Object.assign(document.createElement("div"), {
        id: "drag-placeholder",
        classList: "w-100 d-flex align-items-center justify-content-center position-absolute",
      });
      newPlaceholder.append(
        Object.assign(document.createElement("div"), {
          classList: "arrow right",
        }),
        Object.assign(document.createElement("div"), {
          classList: "line w-100 border-0",
        }),
        Object.assign(document.createElement("div"), {
          classList: "arrow left",
        })
      );
      return newPlaceholder;
    },
    removeDragPlaceholder() {
      const previousPlaceholder = document.getElementById("drag-placeholder");
      previousPlaceholder && previousPlaceholder.remove();
    },
    /* COMMON */
    deleteBlock(blockId) {
      this.apiNamespace
        .delete(this.lessonId, blockId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          const idx = this.blocks.findIndex((b) => b.id === blockId);
          if (this.blocks[idx].model_type_id === this.blockTypes.video) {
            this.reset();
          }
          this.blocks.splice(idx, 1);
        })
        .catch((e) => this.$alert.error("Ошибка удаления блока<br>" + e.message));
    },
    addBlock(typeId, name) {
      if (!typeId) {
        return;
      }

      if (typeId === this.blockTypes.test && this.blocks.find((b) => b.model_type_id === this.blockTypes.test)) {
        this.$alert.error("В уроке может быть только один тест");
        return;
      }

      this.apiNamespace
        .create(this.lessonId, typeId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          switch (name) {
            case "text":
              name = "текст";
              break;
            case "file":
              name = "файл";
              break;
            case "video":
              name = "видео";
              break;
            case "audio":
              name = "аудио";
              break;
            case "image":
              name = "фото";
              break;
            case "test":
              name = "тест";
              break;
            case "survey":
              name = "опрос";
              break;
            case "homework":
              name = "д/з";
              break;
          }

          this.$alert.success(`Блок ${name} создан!`);

          this.load();
        })
        .catch((e) => this.$alert.error("Ошибка создания блока<br>" + e.message));
    },
    updateBlock(block) {
      // визуальное обновление изменений
      this.blocks = this.blocks.map((b) => (b.id === block.id ? block : b));

      // проклятый js и его передача объектов по ссылке
      let blockDeepCopy = JSON.parse(JSON.stringify(block));
      // тест и опрос приходят во вложенной структуре данных
      // поэтому при сохранении необходимо их атрибуты перенести в корневой объекты
      ["test", "survey", "homework"].forEach((prop) => {
        if (blockDeepCopy.model_type_id !== this.blockTypes[prop]) {
          return;
        }
        blockDeepCopy = Object.assign(blockDeepCopy, JSON.parse(JSON.stringify(blockDeepCopy[prop])));
        delete blockDeepCopy[prop];
      });

      this.saveBlock(blockDeepCopy, false);
    },
    saveBlock(block, reload = true) {
      this.apiNamespace
        .save(this.lessonId, block)
        .then((response) => {
          !response.success && this.$alert.error("Ошибка сохранения блока.<br>" + response.error);
        })
        .finally(() => {
          reload && this.load();
        });
    },
    toggleSettingVimeoPreview(video) {
      let idx;
      if (~(idx = this.showSettingVimeoPreviewIds.indexOf(video.id))) {
        this.showSettingVimeoPreviewIds.splice(idx, 1);
        return;
      }
      this.showSettingVimeoPreviewIds.push(video.id);
    },
  },
};
</script>
